const style = {
    container: {
        width: "100%",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        background: "#181a20",
        color: "#FFF",
        padding: "30px 80px",
        boxSizing: "border-box",
    },
    header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        marginBottom: "20px",
    },
    title: {
        fontSize: "28px",
        fontWeight: "600",
        margin: 0,
    },
    newTagButton: {
        display: 'flex',
        alignItems: 'center',
        background: '#4ecf78',
        color: '#1e212b',
        border: 'none',
        borderRadius: '10px',
        padding: '10px 20px',
        fontSize: '16px',
        fontWeight: '600',
        cursor: 'pointer',
    },
    panel: {
        display: "flex",
        gap: "15px",
        width: "100%",
        marginBottom: "20px",
    },
    searchWrapper: {
        position: "relative",
        flexGrow: 1,
    },
    searchIcon: {
        position: "absolute",
        left: "15px",
        top: "50%",
        transform: "translateY(-50%)",
        color: "#aeb9c4",
    },
    searchInput: {
        width: "100%",
        height: "45px",
        background: "#2a2f3b",
        border: "1px solid #3c4257",
        borderRadius: "12px",
        padding: "0 20px 0 45px",
        boxSizing: "border-box",
        color: "#FFF",
        fontSize: "14px",
        outline: "none",
    },
    sortSelect: {
        height: "45px",
        background: "#2a2f3b",
        border: "1px solid #3c4257",
        borderRadius: "12px",
        padding: "0 15px",
        boxSizing: "border-box",
        color: "#FFF",
        fontSize: "14px",
        cursor: "pointer",
        outline: "none",
    },
    gridContainer: {
        flexGrow: 1,
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
        gap: '20px',
        overflowY: 'auto',
        paddingRight: '10px'
    },
    card: {
        background: '#1e212b',
        border: '1px solid #2a2f3b',
        borderRadius: '12px',
        padding: '20px',
        height: "max-content",
        display: 'flex',
        flexDirection: 'column',
        cursor: 'pointer',
    },
    cardTag: {
        fontSize: '16px',
        fontWeight: '600',
        padding: '4px 12px',
        borderRadius: '20px',
        alignSelf: 'flex-start'
    },
    cardDescription: {
        fontSize: '14px',
        color: '#aeb9c4',
        marginTop: '10px',
        flexGrow: 1,
    },
    messageCenter: {
        gridColumn: '1 / -1',
        color: "#aeb9c4",
        textAlign: "center",
        marginTop: "40px",
    },
    paginationContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "20px 0 0 0",
        flexShrink: 0,
        gap: '8px',
    },
    paginationButton: {
        background: "#2a2f3b",
        border: "1px solid #3c4257",
        color: "#aeb9c4",
        height: '36px',
        minWidth: '36px',
        padding: "0 10px",
        borderRadius: "8px",
        cursor: "pointer",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '14px',
        fontWeight: '600'
    },
    paginationView: {
        color: "#aeb9c4",
        fontSize: "14px",
        fontWeight: '500'
    },
    disabledButton: {
        opacity: 0.5,
        cursor: 'not-allowed',
    },
};

export default style;